// Imports
var ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___ = require("../../../../../../../node_modules/html-loader/dist/runtime/getUrl.js");
var ___HTML_LOADER_IMPORT_0___ = require("/src/client/assets/images/googlebtnsignup.png");
// Module
var ___HTML_LOADER_REPLACEMENT_0___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_0___);
var code = "<div ng-if=\"signUpVm.iFor\"> <div class=\"loginor\"><span>or</span></div> <a ng-click=\"signUpVm.signUpCallback()\" class=\"ggl\"> <img src=\"" + ___HTML_LOADER_REPLACEMENT_0___ + "\" width=\"274\" height=\"41\" alt=\"Google\"> </a> </div>";
// Exports
var _module_exports = code;;
var path = 'app/authentication/components/signup/template/signupcontainer.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;